import { Link } from 'react-router-dom';
import styled from 'styled-components';

const UnderlinedLink = styled(Link)`
  display: inline-block;
  color: var(--text-color);
  &:hover {
    text-decoration: underline;
    color: var(--text-color);
  }
`;

export default UnderlinedLink;
